<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="26.046"
    height="19.789"
    viewBox="0 0 26.046 19.789"
  >
    <g transform="translate(-1099.846 -580.356)">
      <path
        d="M1112.866,596.989a.488.488,0,0,1-.2-.041l-12.439-5.369a.5.5,0,0,1-.02-.909l5.729-2.779a.5.5,0,0,1,.436.9l-4.747,2.3,11.234,4.848,11.2-5.09-5.342-2.044a.5.5,0,0,1,.357-.934l6.459,2.471a.5.5,0,0,1,.029.922l-12.489,5.677A.48.48,0,0,1,1112.866,596.989Z"
      />
      <path
        d="M1113,600.145a.506.506,0,0,1-.2-.041l-12.651-5.462a.5.5,0,0,1-.032-.9l3.084-1.6a.5.5,0,1,1,.461.886l-2.148,1.116,11.473,4.954,12.191-5.834a.5.5,0,1,1,.431.9l-12.4,5.932A.509.509,0,0,1,1113,600.145Z"
      />
      <path
        d="M1113.621,593.22s-1.2-3.568-1.871-5.7a8.685,8.685,0,0,1,.9-6.519.5.5,0,0,1,.9.432c-1.143,2.392-1.389,4.069-.849,5.787.668,2.126,1.865,5.681,1.865,5.681Z"
      />
      <path
        d="M1113.821,584.124a.5.5,0,0,1-.493-.424l-.322-2.084-1.729.885a.5.5,0,1,1-.455-.891l2.345-1.2a.506.506,0,0,1,.455,0,.5.5,0,0,1,.267.369l.427,2.769a.5.5,0,0,1-.418.57A.484.484,0,0,1,1113.821,584.124Z"
      />
      <path
        d="M1109.386,592.24a.5.5,0,0,1-.459-.3,32,32,0,0,1-1.468-4.145,5.2,5.2,0,0,1,0-2.481,23.372,23.372,0,0,1,1.113-2.367.5.5,0,0,1,.879.475,24.012,24.012,0,0,0-1.045,2.2,4.239,4.239,0,0,0,.024,1.919,30.888,30.888,0,0,0,1.419,4,.5.5,0,0,1-.459.7Z"
      />
      <path
        d="M1109.416,586.04a.5.5,0,0,1-.493-.426l-.246-1.633-1.747.729a.5.5,0,1,1-.385-.924l2.339-.974a.5.5,0,0,1,.686.387l.341,2.267a.5.5,0,0,1-.42.568A.47.47,0,0,1,1109.416,586.04Z"
      />
      <path
        d="M1117.405,591.221a.5.5,0,0,1-.465-.317c-.06-.151-1.453-3.749.027-6.443a.5.5,0,0,1,.877.48c-1.257,2.288.013,5.563.026,5.6a.5.5,0,0,1-.465.684Z"
      />
      <path
        d="M1118.208,586.262a.5.5,0,0,1-.483-.373l-.388-1.472-1.528.588a.5.5,0,0,1-.36-.934l2.049-.788a.5.5,0,0,1,.663.34l.53,2.012a.5.5,0,0,1-.356.61A.461.461,0,0,1,1118.208,586.262Z"
      />
    </g>
  </svg>
</template>
